var React = require('react');

function Flute (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M608 176H96v160h512a32 32 0 0 0 32-32v-96a32 32 0 0 0-32-32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M320 232a24 24 0 1 0 24 24 24 24 0 0 0-24-24zM0 208v96a32 32 0 0 0 32 32h64V176H32a32 32 0 0 0-32 32zm416 24a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm96 0a24 24 0 1 0 24 24 24 24 0 0 0-24-24z","className":"fa-primary","key":2})]);
}

Flute.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Flute;

Flute.default = Flute;
